import { connect } from 'react-redux';
import { filter, includes, values } from 'lodash/fp';
import {
  fetchInventoryPackage,
  deleteInventoryPackage,
  fetchInventoryPackageSkus,
  fetchInventoryPackageItems,
  fetchInventoryPackageAvailability
} from '../../../../../redux/Inventory/sagas/routines';
import { fetchInventoryActionOptions } from '../../../../../redux/Inventory/sagas/components/view-item/routines';
import {
  getIsFetching,
  getIsDeleting,
  getIsDeleted,
  getPackageForId
} from '../../../../../redux/Inventory/selectors/package';
import {
  getIsFetchingByItem,
  getAvailabilityForItemId
} from '../../../../../redux/Inventory/selectors/package/availability';
import {
  getPackageItems,
  getIsFetchingPackageItems
} from '../../../../../redux/Inventory/selectors/components/item-form';
import {
  getActionOptions,
  getIsFetchingActionOptions
} from '../../../../../redux/Inventory/selectors/components/view-item';
import InventoryActions from '../../../../../constants/inventory/InventoryActions';
import { PackageType } from '../../../../../constants/inventory/InventoryTypes';
import ViewInventoryItem from '../../component';
import { getSkusForPackageId } from '../../../../../redux/Inventory/selectors/package/skus';

const allowedAction = [InventoryActions.REMOVE];

function mapStateToProps(state, { match: { params } }) {
  const { id } = params;
  const allActionOptions = getActionOptions(state);
  const actionOptions = filter(
    ({ value }) => includes(value, allowedAction),
    allActionOptions
  );
  return {
    params,
    actionOptions,
    type: PackageType,
    item: getPackageForId(state, id),
    skus: values(getSkusForPackageId(state, id)),
    packageItems: values(getPackageItems(state, id)),
    availability: getAvailabilityForItemId(state, id),
    isFetching: getIsFetching(state),
    isFetchingPackageItems: getIsFetchingPackageItems(state),
    isFetchingAvailability: getIsFetchingByItem(state),
    isFetchingActionOptions: getIsFetchingActionOptions(state),
    isDeleting: getIsDeleting(state),
    isDeleted: getIsDeleted(state)
  };
}

function mapDispatchToProps(dispatch, { match: { params } }) {
  const { id } = params;
  return {
    onInit: () => {
      dispatch(fetchInventoryPackage(id));
      dispatch(fetchInventoryPackageSkus(id));
      dispatch(fetchInventoryPackageItems(id));
      dispatch(fetchInventoryPackageAvailability(id));
      dispatch(fetchInventoryActionOptions());
    },
    onDelete: item => {
      dispatch(deleteInventoryPackage(item));
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ViewInventoryItem);
